import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["review", "searchTerm", "catalogServices", "reviewType", "showOriginal", "showUntranslatedText", "onTrackInteraction"];
import FormattedList from 'I18n/components/FormattedList';
import FormattedMessage from 'I18n/components/FormattedMessage';
import isValidI18nKey from 'I18n/utils/isValidI18nKey';
import { Text } from 'foundations-components/components/Text';
import { View } from 'foundations-components/transitional/components/View';
import { BreakString } from 'foundations-components/transitional/components/BreakString';
import * as ReviewQuestions from '../constants/ReviewQuestions';
import { MINIMUM_SEARCH_LENGTH } from '../constants/ReviewsListQueries';
import ReviewSection from './ReviewSection';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function ReviewBody(_ref) {
  var _review$untranslated;
  let {
      review,
      searchTerm,
      catalogServices,
      reviewType,
      showOriginal,
      showUntranslatedText
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const originalAnswers = showUntranslatedText ? Object.fromEntries(review.get('original').answers) // TODO: update to get untranslated originals when supported by BE
  : Object.fromEntries(review.get('original').answers);
  const answers = showUntranslatedText ? (_review$untranslated = review.untranslated) !== null && _review$untranslated !== void 0 && _review$untranslated.answers ? Object.fromEntries(review.untranslated.answers) : Object.fromEntries(review.get('answers')) : Object.fromEntries(review.get('answers'));
  const displayedAnswers = showOriginal ? originalAnswers : answers;
  const tags = showOriginal ? Object.fromEntries(review.get('original').tags) : Object.fromEntries(review.get('tags'));
  const customizableKey = reviewType === 'THEME' ? 'CUSTOMIZABLE_THEME' : 'CUSTOMIZABLE_MODULE';
  const renderAnswer = question => {
    const answer = displayedAnswers[question];
    let renderedAnswer = answer;
    if (!answer) {
      return null;
    }
    const textKey = `marketplace-ui-reviews.responses.${question === 'CUSTOMIZABLE' ? customizableKey : question}`;
    const title = isValidI18nKey(textKey) && /*#__PURE__*/_jsx(FormattedMessage, {
      message: textKey
    });
    if (searchTerm && searchTerm.length >= MINIMUM_SEARCH_LENGTH) {
      const regex = new RegExp(`((?=${searchTerm})|(?<=${searchTerm}))`, 'i');
      const splitText = answer.split(regex);
      renderedAnswer = splitText.map((text, index) => {
        return /*#__PURE__*/_jsx(View, {
          as: "span",
          backgroundColor: text.toLowerCase() === searchTerm.toLowerCase() ? 'fill-accent-yellow-default' : undefined,
          children: text
        }, index);
      });
    }
    return /*#__PURE__*/_jsx(ReviewSection, {
      title: title,
      children: question === 'TITLE' ? /*#__PURE__*/_jsx(Text, {
        as: "h4",
        children: /*#__PURE__*/_jsx(BreakString, {
          children: renderedAnswer
        })
      }) : /*#__PURE__*/_jsx(Text, {
        children: /*#__PURE__*/_jsx(BreakString, {
          children: renderedAnswer
        })
      })
    }, question);
  };
  const renderTags = tagField => {
    const tagList = tags[tagField];
    if (!tagList || !tagList.length) {
      return null;
    }
    const textKey = `marketplace-ui-reviews.responses.${tagField}`;
    const title = isValidI18nKey(textKey) && /*#__PURE__*/_jsx(FormattedMessage, {
      message: textKey
    });
    if (tagField === 'CATALOG_SERVICES' && catalogServices) {
      return /*#__PURE__*/_jsx(ReviewSection, {
        title: title,
        children: /*#__PURE__*/_jsx("span", {
          children: /*#__PURE__*/_jsx(BreakString, {
            children: /*#__PURE__*/_jsx(FormattedList, {
              children: tagList.map(service => {
                const selectedService = catalogServices.filter(catService => catService.id === service)[0];
                return selectedService && selectedService.name || '';
              })
            })
          })
        })
      }, tagField);
    }
    return /*#__PURE__*/_jsx(ReviewSection, {
      title: title,
      children: /*#__PURE__*/_jsx("span", {
        children: /*#__PURE__*/_jsx(BreakString, {
          children: /*#__PURE__*/_jsx(FormattedList, {
            children: tagList.map(tag => tag)
          })
        })
      })
    }, tagField);
  };
  if (!review.hasContent()) {
    return null;
  }
  return /*#__PURE__*/_jsxs(View, Object.assign({}, rest, {
    children: [ReviewQuestions.QuestionOrder.map(question => renderAnswer(question)), ReviewQuestions.TagOrder.map(tagField => renderTags(tagField))]
  }));
}